import React from "react";
import CustomTab from "../../components/ui/CustomTab";

const tabs = [
  {
    label: "Quota Modification",
    to: "quota-modification",
    value: "/approval/quota-modification",
  },
  {
    label: "Quota",
    to: "quota",
    value: "/approval/quota"
  },
  {
    label: "Scenario",
    to: "scenario",
    value: "/approval/scenario"
  }
  
];

export default function Approval() {
	return (
    <CustomTab tabs={tabs}/>
	);
}
